export default {
  ...window.partisans_config,
  apiVersion: 'v1'
}
